var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifebuoyFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.5rem",
    height: "1.5rem",
    viewBox: "0 0 24 24",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    style: {
      fill: "none"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.032,2.25L11.968,2.25C9.29,2.259 6.865,3.349 5.107,5.107C5.1,5.114 5.093,5.121 5.086,5.128C3.333,6.891 2.25,9.32 2.25,12C2.25,14.68 3.333,17.109 5.086,18.872C5.093,18.879 5.1,18.886 5.107,18.893C6.871,20.658 9.309,21.75 12,21.75C14.691,21.75 17.129,20.658 18.893,18.893C18.9,18.886 18.907,18.879 18.914,18.872C20.667,17.109 21.75,14.68 21.75,12C21.75,9.32 20.667,6.891 18.914,5.128C18.907,5.121 18.9,5.114 18.893,5.107C17.135,3.349 14.71,2.259 12.032,2.25ZM5.661,6.722C4.468,8.153 3.75,9.993 3.75,12C3.75,14.007 4.468,15.847 5.661,17.278L8.153,14.786C7.585,14.003 7.25,13.041 7.25,12C7.25,10.959 7.585,9.997 8.153,9.214L5.661,6.722ZM18.339,6.722L15.847,9.214C16.415,9.997 16.75,10.959 16.75,12C16.75,13.041 16.415,14.003 15.847,14.786L18.339,17.278C19.532,15.847 20.25,14.007 20.25,12C20.25,9.993 19.532,8.153 18.339,6.722ZM12,8.75C13.794,8.75 15.25,10.206 15.25,12C15.25,13.794 13.794,15.25 12,15.25C10.206,15.25 8.75,13.794 8.75,12C8.75,10.206 10.206,8.75 12,8.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifebuoyFilled);
export default __webpack_public_path__ + "static/media/lifebuoy_filled.223a1e19.svg";
export { ForwardRef as ReactComponent };